/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import Auth from '../Auth';
import Link from '../../../../../components/Link';
import Callout from '../../../../../components/Callout';
import Form from '../../../../../components/Form';
import Text from '../../../../../components/Form/Input/Text';
import Checkbox from '../../../../../components/Form/Input/Checkbox';
import history from '../../../../../history';
import { RUNTIME_MODAL } from '../../../../../constants';
import { setRuntimeVariable } from '../../../../../actions/runtime';
import { sites } from '../../../../../configPublic';

const messages = defineMessages({
  instructions: {
    id: 'auth.forgot.instructions',
    defaultMessage:
      'If email address is valid, you will receive an email with further instructions to reset password.',
    description: 'Instructions to reset password Message',
  },
  login: {
    id: 'auth.forgot.login',
    defaultMessage: 'LOGIN',
    description: 'Login Link',
  },
  signup: {
    id: 'auth.forgot.signup',
    defaultMessage: 'SIGN UP',
    description: 'Sign Up Link',
  },
  member: {
    id: 'auth.forgot.member',
    defaultMessage: 'Already member on mySKP?',
    description: 'Already member Message',
  },
  support: {
    id: 'auth.forgot.support',
    defaultMessage: 'Need support?',
    description: 'support Message',
  },
  clickHere: {
    id: 'auth.forgot.clickHere',
    defaultMessage: 'Click Here',
    description: 'Click Here Link',
  },
  memberLogin: {
    id: 'auth.forgot.memberLogin',
    defaultMessage: 'Log in',
    description: 'Log in Link',
  },
  subscribeMessage: {
    id: 'auth.forgot.subscribeMessage',
    defaultMessage:
      'Yes, I would to receive commercial electronic information and offers from { company }, (“SKP”). I may later unsubscribe. [{ company }, Inc. 2515 Meadowpine Blvd., Mississauga, ON L5N 6C3 905-814-6511].',
    description: 'Subscribe Message',
  },
});

class Forgot extends Component {
  static contextTypes = {
    url: PropTypes.object.isRequired,
    routeParams: PropTypes.object.isRequired,
    fetch: PropTypes.func.isRequired,
    query: PropTypes.object.isRequired,
    intl: PropTypes.object.isRequired,
  };

  static propTypes = {
    title: PropTypes.string.isRequired,
    showTerms: PropTypes.func.isRequired,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      submitting: false,
      submitSuccess: false,
      value: {},
    };
  }

  componentDidMount() {
    const { session } = this.props; //eslint-disable-line
    const { url, routeParams } = this.context;
    if (session.USER_DATA) {
      history.replace(url.getUrl('home', routeParams));
    }
  }

  async submitHandler(e) {
    const { siteId } = this.context.routeParams;
    this.setState({ submitting: true, value: e.value, submitSuccess: false });

    const resp = await this.context.fetch(`/${siteId}/auth/forgot`, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: e.value.email,
      }),
      credentials: 'include',
    });
    // if (resp.status !== 200) throw new Error(resp.statusText);
    const data = await resp.json();
    this.setState({ submitting: false, submitSuccess: true, value: {} });
  }

  render() {
    const { url, routeParams, intl } = this.context;
    const { siteId } = routeParams;
    const Terms = sites[routeParams.siteId].terms(intl).generalTerms.component;
    const TermsLabel = sites[routeParams.siteId].terms(intl).generalTerms.label;
    const TermsProps = sites[routeParams.siteId].terms(intl).generalTerms.props;

    const TermsAdditional = sites[routeParams.siteId].terms(intl)
      .additionalTerms.component;
    const TermsAdditionalLabel = sites[routeParams.siteId].terms(intl)
      .additionalTerms.label;
    const TermsAdditionalProps = sites[routeParams.siteId].terms(intl)
      .additionalTerms.props;

    const callout = this.state.submitSuccess ? (
      <Callout size="small" type="success">
        <FormattedMessage {...messages.instructions} />
      </Callout>
    ) : null;

    return (
      <Auth>
        <div className="auth__form">
          <div className="flex-center auth__links">
            <Link
              className="link link--medium"
              to={url.getUrl('auth-index', routeParams)}
              activeClassName="is-active"
            >
              <FormattedMessage {...messages.login} />
            </Link>
            <Link
              className="link link--medium"
              to={url.getUrl('auth-register', routeParams)}
              activeClassName="is-active"
            >
              <FormattedMessage {...messages.signup} />
            </Link>
          </div>

          <div className="auth__main">
            {callout}

            <Form
              title={this.props.title}
              // onInvalidSubmit={this.onInvalidSubmit.bind(this)}
              onValidSubmit={this.submitHandler.bind(this)}
              submitButtonLabel={
                this.state.submitting ? '...submitting' : 'RECOVER PASSWORD'
              }
              value={this.state.value}
              isSubmitting={this.state.submitting}
            >
              <Text
                label="Email Address"
                helpText=""
                errorText="Valid email address required."
                name="email"
                validators="isEmail"
                required
              />
              {this.context.query.verify != null ? (
                <div>
                  <Checkbox
                    label=""
                    helpText=""
                    errorText="You must agree to terms."
                    validators={val => val === true}
                    name="_agree"
                    // required
                  >
                    <span>
                      I have read and agree to the{' '}
                      <a
                        role="button"
                        tabIndex={0}
                        onClick={() => {
                          this.props.showTerms({
                            title: TermsLabel,
                            body: <Terms {...TermsProps} />,
                          });
                        }}
                      >
                        Terms of Use and Privacy Policy
                      </a>
                      , and{' '}
                      <a
                        role="button"
                        tabIndex={0}
                        onClick={() => {
                          this.props.showTerms({
                            title: TermsAdditionalLabel,
                            body: <TermsAdditional {...TermsAdditionalProps} />,
                          });
                        }}
                      >
                        MYSKP Additional Terms Of Use And Privacy Supplement
                      </a>
                    </span>
                  </Checkbox>
                  <div className="auth__agree pt20">
                    <Checkbox
                      label=""
                      helpText=""
                      errorText="You must agree subscribe."
                      validators={val => val === true}
                      name="_subscribe"
                      // required
                    >
                      <span>
                        <FormattedMessage
                          {...messages.subscribeMessage}
                          values={{
                            company: sites[routeParams.siteId].company,
                          }}
                        />
                      </span>
                    </Checkbox>
                  </div>
                </div>
              ) : null}
            </Form>
          </div>

          <p className="auth__help">
            <FormattedMessage {...messages.member} />{' '}
            <Link
              className="auth__link"
              to={url.getUrl('auth-index', routeParams)}
            >
              <FormattedMessage {...messages.memberLogin} />
            </Link>
            {/* <br />
            <FormattedMessage {...messages.support} />{' '}
            <a
              className="auth__link"
              href={sites[siteId].contact.support}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FormattedMessage {...messages.clickHere} />
            </a> */}
          </p>
        </div>
      </Auth>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  showTerms: ({ title, body }) => {
    dispatch(
      setRuntimeVariable({
        name: RUNTIME_MODAL,
        value: {
          type: 'full',
          payload: {
            title,
            body,
          },
        },
      }),
    );
  },
  dispatch,
});

// export default Login;
export default connect(
  state => ({ session: state.session }),
  mapDispatchToProps,
)(Forgot);



// WEBPACK FOOTER //
// ./src/routes/client/site/auth/password-forgot/Forgot.js